var React = require('react');

function CheckmarkHeavy (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.6616 5.02965C16.9213 5.25695 16.9477 5.6518 16.7204 5.91157L7.97036 15.9116C7.85645 16.0418 7.69368 16.1189 7.5208 16.1247C7.34791 16.1304 7.18037 16.0643 7.05806 15.942L3.30806 12.192C3.06398 11.9479 3.06398 11.5521 3.30806 11.3081C3.55214 11.064 3.94786 11.064 4.19194 11.3081L7.46956 14.5857L15.7796 5.08844C16.0069 4.82867 16.4018 4.80235 16.6616 5.02965Z","fill":"#4CAF50","stroke":"#4CAF50","strokeWidth":"2.4","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckmarkHeavy.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = CheckmarkHeavy;

CheckmarkHeavy.default = CheckmarkHeavy;
